import { useAtom } from 'jotai'
import { Link, Navigate, Outlet } from 'react-router-dom'

import LogoImage from '@/assets/images/logo-gata.svg?react'
import { atomLoginStatus, LoginStatus } from '@/stores/login'

export function AuthLayout() {
  const [loginStatus] = useAtom(atomLoginStatus)

  if (loginStatus === LoginStatus.login) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="h-full flex flex-col bg-[url(@/assets/images/bg-page.svg)] bg-cover">
      <header className="px-8 py-[18px] sticky top-0 z-[50]">
        <div className="w-fit flex flex-row gap-4 items-center">
          <Link to="/" replace>
            <LogoImage width={140} height={32} />
          </Link>
          <div className="h-5 border-r border-r-[#E1E4EA]"></div>
          <div className="w-80 h5 text-primary">DeCloud</div>
        </div>
      </header>
      <main className="flex-grow flex items-center justify-center h-full overflow-y-auto">
        <Outlet />
      </main>
    </div>
  )
}
